export default __webpack_public_path__ + "static/typography-image-a-fa56ff14cf97dc853b29e866517d4f2e3b1c81e522bd90e190363aa9503ad9f8.png";